import { CarsState } from '../../types';

import { carsActions } from '../reducer';

export const updateCarsLocationHistorySharingFilter = (
  filter: Partial<CarsState['locationHistorySharing']['filter']>
) => carsActions.updateCarsLocationHistorySharingFilter(filter);
